import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { globalStyles } from '../../core/style/gstheme';

const styles = theme => {
  return Object.assign({
    applicationCard: {
      width: 282,
      boxShadow: '0px 1px 3px #00000033',
      '&:hover': {
        boxShadow: '0px 12px 17px #00000024',
        backgroundColor: '#50832C',
        color: 'white'
      }
    },
    applicationCardDetail: {
      display: 'flex',
      height: 140,
      flexDiretion: 'column',
      alignItems: 'flex-start'
    },
    applicationCardAction: {
      alignSelf: 'flex-end'
    },
    cardLink: {
      margin: 20,
      textDecoration: 'none'
    },
    applicationCardContent: {
      flexBasis: 220
    },
    media: {
      backgroundColor: theme.palette.primary.main,
      borderBottom: 'solid 2px ' + theme.palette.secondary.main,
      backgroundSize: 'auto',
      height: 194,
    },
    description: {
      height: '100px',
      overflowY: 'scroll'
    },
  }, globalStyles)
};

class ApplicationCard extends React.Component {

  state = {
    active: null
  }

  onActivate = () => this.setState({ active: true });

  onDeactivate = () => this.setState({ active: false });

  render() {

    const { active } = this.state;
    const { classes, url, isManagedUrl, title, description, thumbnail, id, dataTest } = this.props;

    const card =
      <Card className={classes.applicationCard}
        name={id}
        data-test={dataTest}
        onMouseEnter={this.onActivate}
        onMouseLeave={this.onDeactivate}>
        <CardMedia className={classes.media} image={thumbnail} title={title} />
        <div className={classes.applicationCardDetail}>
          <CardContent className={classes.applicationCardContent}>
            <Typography
              gutterBottom
              component="h2"
              className={classes.mainHeading}
              style={active ? { color: 'white' } : {}}>{title}</Typography>
            <Typography variant="body2" component="p">{description}</Typography>
          </CardContent>
          <CardActions className={classes.applicationCardAction}>
            <IconButton size="small">
              <ArrowForwardIcon className={classes.actionButton} />
            </IconButton>
          </CardActions>
        </div>
      </Card>;

    return (
      <React.Fragment>
        {isManagedUrl ?
          <NavLink to={url} className={classes.cardLink}>
            {card}
          </NavLink>
          :
          <a rel="noreferrer" target="_blank" style={{ margin: '20px' }} href={url}>{card}</a>
        }
      </React.Fragment>
    );
  }
}

ApplicationCard.defaultProps = {
  isManagedUrl: true
};

ApplicationCard.propTypes = {
  classes: PropTypes.object,
  dataTest: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  isManagedUrl: PropTypes.bool,
  url: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired
};

export default withStyles(styles)(ApplicationCard);